import React from "react";
import { Users, Shield, CheckCircle } from "lucide-react";

const FeaturesSection = () => {
  const features = [
    {
      icon: <Users className="w-12 h-12 text-blue-600" />,
      title: "Personalized Attention",
      description: "We listen, understand, and adapt our services to fit your unique needs."
    },
    {
      icon: <Shield className="w-12 h-12 text-blue-600" />,
      title: "Reliability You Can Trust",
      description: "On-time, professional, and committed to delivering consistent results."
    },
    {
      icon: <CheckCircle className="w-12 h-12 text-blue-600" />,
      title: "Complete Solutions",
      description: "From start to finish, we make the process simple, efficient, and stress-free."
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white p-8 rounded-lg shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-2 text-center"
            >
              <div className="flex justify-center mb-4">
                {feature.icon}
              </div>
              <h3 className="text-xl font-bold mb-3 text-gray-900">{feature.title}</h3>
              <p className="text-gray-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;